import { TemplatePage } from './types';

const lifestylePage: TemplatePage = {
  header: {
    color: '#FFCA6C',
    icon: 'images/video-templates/lifestyle.jpg',
    title: 'Lifestyle Video Templates Collection',
    title_meta: '50+ Free and Customizable Lifestyle Video Templates',
    description_meta:
      'A collection of lifestyle video templates to help you create interesting, engaging and inspiring content for your ' +
      'lifestyle blog.',
    description:
      'Reveal the beauty and joy of everyday life with dynamic and inspiring lifestyle videos. Create a vivid mixture of ' +
      'personal experiences and valuable content for your audience. Draw attention to your lifestyle blog and build a dynamic community of like-minded people.'
  },
  footer: {
    category: 'Lifestyle',
    description:
      'Beautiful video templates coupled with rich customization features make a shortcut to effortless video production. ' +
      'Wave.video offers a rich collection of video templates featuring separate sets for diverse industries and use cases. ' +
      'Plus, all templates come in several sizes so that you can create consistently-looking video content for various platforms ' +
      'and channels. Browse video templates, pick out the ones you like, and easily transform them into your unique content pieces.'
  },
  content: [
    {
      type: 'templates',
      title: 'lifestyle',
      search: { category: '/Industries/Lifestyle' }
    },
    {
      type: 'stocks',
      title: 'lifestyle',
      search: { name: 'lifestyle' }
    },
    { type: 'calendar' }
  ]
} as TemplatePage;

export default lifestylePage;
